export const testcases = {
    default: {
        name: 'default',
        scanned: ['uri', 'nonce', 'salt', 'client_version', 'protocol_version'],
        confirmed: [
            'auth_adr', 'auth_sig', 'device', 'nonce', 'salt', 'sig_target', 'uri', 'wallet_name', 'target_adr', 'client_version', 'protocol_version'],
        authorization: true
    },
    eth: {
        name: 'eth',
        scanned: ['uri', 'nonce', 'salt', 'client_version', 'protocol_version'],
        confirmed: ['auth_adr', 'auth_sig', 'device', 'nonce', 'salt', 'sig_target', 'uri', 'wallet_name', 'target_adr', 'client_version', 'protocol_version', 'eth_sig'],
        authorization: true
    },
    verification_fail: {
        name: 'verification_fail',
        scanned: ['uri', 'nonce', 'salt', 'client_version', 'protocol_version'],
        confirmed: ['verification_failed'],
        authorization: false
    },
    sig_domain: {
        name: 'sig_domain',
        scanned: ['uri', 'nonce', 'salt', 'client_version', 'protocol_version'],
        confirmed: [
            'auth_adr', 'auth_sig', 'device', 'nonce', 'salt', 'sig_domain', 'sig_target', 'uri', 'wallet_name', 'xauth_adr', 'xauth_sig', 'target_adr', 'client_version', 'protocol_version'],
        authorization: true
    },
    // sig_domain_2: {
    //     name: 'sig_domain_2',
    //     scanned: ['uri', 'nonce', 'salt', 'client_version', 'protocol_version'],
    //     confirmed: [
    //         'auth_adr', 'auth_sig', 'device', 'nonce', 'salt', 'sig_domain', 'sig_target', 'uri', 'wallet_name', 'xauth_adr', 'xauth_sig', 'target_adr', 'client_version', 'protocol_version'],
    //     authorization: true
    // },
}